import { Typography, TypographyProps } from '@spazious/dollhouse-uikit';

export interface ErrorMessageProps extends TypographyProps {
  message?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, ...restProps }) =>
  message && (
    <Typography color="error" size="large" style={{ flex: 1 }} variant="label" {...restProps}>
      {message}
    </Typography>
  );
